import React from 'react';
import {
  Box,
  Button,
  HStack,
  MenuButton,
  Text,
  useStyleConfig,
  VStack,
} from '@chakra-ui/react';

export interface FilterMenuButtonProps {
  headline?: string;
  information: string;
  trailingIcon?: any;
  variant?: string;
}
export const ChakraSelectButton = (props: FilterMenuButtonProps): JSX.Element => {
  const { headline, information, trailingIcon, variant } = props;
  const menuButtonStyles = useStyleConfig('MenuButton', {
    variant: variant ? variant : 'chakraSelect.MenuButton',
  });

  return (
    <MenuButton __css={menuButtonStyles} as={Button} w={'100%'}>
      <HStack>
        <VStack alignItems={trailingIcon ? 'inherit' : 'flex-start'} spacing={0} style={{overflow: "hidden"}}>
          {headline && <Text textStyle={'chakraSelect.button.headline'}>{headline}</Text>}
          <Text fontSize={'sm'} style={{textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>{information}</Text>
        </VStack>
        {trailingIcon && (
          <Box flex={1} textAlign={'end'}>
            {trailingIcon}
          </Box>
        )}
      </HStack>
    </MenuButton>
  );
};
